/* eslint-disable */

<template>
  <div>

    <vue-sortable :options="options" @drag:start="startedDrag" @drag:stop="stoppedDrag" @sortable:sort="sort">
      <div class="vx-row " :class="{'cursor-drag' : draggingCard === true}">
        <div class="vx-col lg:w-3/12 md:w-3/12 sm:w-5/5">
          <vx-card class="mb-4">
            <h3 class="font-bold mb-4">Extensions</h3>
            <vue-draggable-container id="wb0" class="wordBank">
              <h5 class="dragBlock my-2 font-semibold cursor-pointer ">commonName</h5>
              <h5 class="dragBlock my-2 font-semibold cursor-pointer ">policyIdentifier</h5>
              <h5 class=" dragBlock my-2 font-semibold cursor-pointer ">subjAltName</h5>
              <h5 class="dragBlock my-2 font-semibold cursor-pointer ">extendedKeyUsage</h5>
            </vue-draggable-container>
          </vx-card>
          <vx-card class="mb-4">
            <h3 class="font-bold mb-4">Values</h3>
            <vue-draggable-container id="wb1" class="wordBank">
              <h5 class="dragBlock my-2 font-semibold cursor-pointer ">clientAuth</h5>
              <h5 class="dragBlock my-2 font-semibold cursor-pointer ">serverAuth</h5>
              <h5 class="dragBlock my-2 font-semibold cursor-pointer ">URL=http://homesite.comptia.org/home.aspx</h5>
              <h5 class="dragBlock my-2 font-semibold cursor-pointer ">ws01.comptia.org</h5>
              <h5 class="dragBlock my-2 font-semibold cursor-pointer ">OCSP;URI:http://ocsp.pki.comptia.org</h5>
              <h5 class="dragBlock my-2 font-semibold cursor-pointer ">DNS Name=*.comptia.org</h5>
              <h5 class="dragBlock my-2 font-semibold cursor-pointer ">DNS Name=homesite.comptia.org</h5>
            </vue-draggable-container>
          </vx-card>
        </div>
        <div class="vx-col lg:w-9/12 md:w-9/12 sm:w-5/5">
          <vx-card class="mb-base">
            <div class="fourth-sim pt-0">
              <div class="vx-row mb-4">
                <div class="vx-col w-6/12 flex items-center">
                  <h2 class="font-bold">Extensions</h2>
                </div>
                <div class="vx-col w-6/12 flex items-center">
                  <h2 class="font-bold">Values</h2>
                </div>
              </div>
              <div class="vx-row border-white border-2 border-solid rounded p-4 ">
                <div class="vx-col w-6/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg " id="inputExt0">
                  </vue-draggable-container>
                </div>
                <div class="vx-col w-6/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg " id="inputVal0">
                  </vue-draggable-container>
                </div>
              </div>
              <div class="vx-row border-white border-2 border-solid rounded p-4 my-4">
                <div class="vx-col w-6/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg " id="inputExt1">
                  </vue-draggable-container>
                </div>
                <div class="vx-col w-6/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg " id="inputVal1">
                  </vue-draggable-container>
                </div>
              </div>
              <div class="vx-row border-white border-2 border-solid rounded p-4 my-4">
                <div class="vx-col w-6/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg " id="inputExt2">
                  </vue-draggable-container>
                </div>
                <div class="vx-col w-6/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg " id="inputVal2">
                  </vue-draggable-container>
                </div>
              </div>
              <div class="vx-row border-white border-2 border-solid rounded p-4 my-4">
                <div class="vx-col w-6/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg " id="inputExt3">
                  </vue-draggable-container>
                </div>
                <div class="vx-col w-6/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg " id="inputVal3">
                  </vue-draggable-container>
                </div>
              </div>
            </div>
          </vx-card>
        </div>
      </div>
    </vue-sortable>
  </div>
</template>

<script>

import draggable from 'vuedraggable'
import Prism from 'vue-prism-component'

export default {
  data () {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      draggingCard: false,
      //last_drag_error: false,

      options: {
        draggable: '.dragBlock',
        dropzone: '.dropzoneStandard'

      }
    }
  },
  methods: {
    startedDrag (x) {
      x.data.source.className += ' currently-dragging-standard'
      this.draggingCard = true
    },
    stoppedDrag () {
      this.draggingCard = false
    },
    sort (x) {
      const overContainer = x.data.dragEvent.data.overContainer
      const sourceContainer = x.data.dragEvent.data.sourceContainer
      if (overContainer && overContainer.id !== 'wb0' && overContainer.id !== 'wb1' && overContainer.children) {
        if (overContainer.children.length > 0 && overContainer.id !== sourceContainer.id) {
          // this.drag_error()
          x.cancel()
        }
      }
    },
    /*  drag_error () {
        const now = new Date().getTime()
        if (this.last_drag_error === false || (now - this.last_drag_error) > 7500) {
          this.last_drag_error = now
          this.$vs.notify(
            {
              color: 'warning',
              title: 'Maximum One Answer Per Input',
              position: 'top-center',
              icon: 'feather',
              iconPack: 'icon-alert-circle',
            })
        }
      }, */
    markSimulation () {

      let total_score = 0

      if (document.getElementById('inputExt0').textContent === 'extendedKeyUsage' && document.getElementById('inputVal0').textContent === 'clientAuth') {
        total_score++
        document.getElementById('inputVal0').style.borderColor = '#77FAAE'
        document.getElementById('inputExt0').style.borderColor = '#77FAAE'
        document.getElementById('inputVal0').style.backgroundColor = '#77FAAE'
        document.getElementById('inputExt0').style.backgroundColor = '#77FAAE'
      }
      if (document.getElementById('inputExt1').textContent === 'extendedKeyUsage' && document.getElementById('inputVal1').textContent === 'clientAuth') {
        total_score++
        document.getElementById('inputVal1').style.borderColor = '#77FAAE'
        document.getElementById('inputExt1').style.borderColor = '#77FAAE'
        document.getElementById('inputVal1').style.backgroundColor = '#77FAAE'
        document.getElementById('inputExt1').style.backgroundColor = '#77FAAE'
      }
      if (document.getElementById('inputExt2').textContent === 'extendedKeyUsage' && document.getElementById('inputVal2').textContent === 'clientAuth') {
        total_score++
        document.getElementById('inputVal2').style.borderColor = '#77FAAE'
        document.getElementById('inputExt2').style.borderColor = '#77FAAE'
        document.getElementById('inputVal2').style.backgroundColor = '#77FAAE'
        document.getElementById('inputExt2').style.backgroundColor = '#77FAAE'
      }
      if (document.getElementById('inputExt3').textContent === 'extendedKeyUsage' && document.getElementById('inputVal3').textContent === 'clientAuth') {
        total_score++
        document.getElementById('inputVal3').style.borderColor = '#77FAAE'
        document.getElementById('inputExt3').style.borderColor = '#77FAAE'
        document.getElementById('inputVal3').style.backgroundColor = '#77FAAE'
        document.getElementById('inputExt3').style.backgroundColor = '#77FAAE'
      }
      if (document.getElementById('inputExt0').textContent === 'extendedKeyUsage' && document.getElementById('inputVal0').textContent === 'serverAuth') {
        total_score++
        document.getElementById('inputVal0').style.borderColor = '#77FAAE'
        document.getElementById('inputExt0').style.borderColor = '#77FAAE'
        document.getElementById('inputVal0').style.backgroundColor = '#77FAAE'
        document.getElementById('inputExt0').style.backgroundColor = '#77FAAE'
      }
      if (document.getElementById('inputExt1').textContent === 'extendedKeyUsage' && document.getElementById('inputVal1').textContent === 'serverAuth') {
        total_score++
        document.getElementById('inputVal1').style.borderColor = '#77FAAE'
        document.getElementById('inputExt1').style.borderColor = '#77FAAE'
        document.getElementById('inputVal1').style.backgroundColor = '#77FAAE'
        document.getElementById('inputExt1').style.backgroundColor = '#77FAAE'
      }
      if (document.getElementById('inputExt2').textContent === 'extendedKeyUsage' && document.getElementById('inputVal2').textContent === 'serverAuth') {
        total_score++
        document.getElementById('inputVal2').style.borderColor = '#77FAAE'
        document.getElementById('inputExt2').style.borderColor = '#77FAAE'
        document.getElementById('inputVal2').style.backgroundColor = '#77FAAE'
        document.getElementById('inputExt2').style.backgroundColor = '#77FAAE'
      }
      if (document.getElementById('inputExt3').textContent === 'extendedKeyUsage' && document.getElementById('inputVal3').textContent === 'serverAuth') {
        total_score++
        document.getElementById('inputVal3').style.borderColor = '#77FAAE'
        document.getElementById('inputExt3').style.borderColor = '#77FAAE'
        document.getElementById('inputVal3').style.backgroundColor = '#77FAAE'
        document.getElementById('inputExt3').style.backgroundColor = '#77FAAE'
      }

      if (document.getElementById('inputExt0').textContent === 'commonName' && document.getElementById('inputVal0').textContent === 'ws01.comptia.org') {
        total_score++
        document.getElementById('inputVal0').style.borderColor = '#77FAAE'
        document.getElementById('inputExt0').style.borderColor = '#77FAAE'
        document.getElementById('inputVal0').style.backgroundColor = '#77FAAE'
        document.getElementById('inputExt0').style.backgroundColor = '#77FAAE'
      }
      if (document.getElementById('inputExt1').textContent === 'commonName' && document.getElementById('inputVal1').textContent === 'ws01.comptia.org') {
        total_score++
        document.getElementById('inputVal1').style.borderColor = '#77FAAE'
        document.getElementById('inputExt1').style.borderColor = '#77FAAE'
        document.getElementById('inputVal1').style.backgroundColor = '#77FAAE'
        document.getElementById('inputExt1').style.backgroundColor = '#77FAAE'
      }
      if (document.getElementById('inputExt2').textContent === 'commonName' && document.getElementById('inputVal2').textContent === 'ws01.comptia.org') {
        total_score++
        document.getElementById('inputVal2').style.borderColor = '#77FAAE'
        document.getElementById('inputExt2').style.borderColor = '#77FAAE'
        document.getElementById('inputVal2').style.backgroundColor = '#77FAAE'
        document.getElementById('inputExt2').style.backgroundColor = '#77FAAE'
      }
      if (document.getElementById('inputExt3').textContent === 'commonName' && document.getElementById('inputVal3').textContent === 'ws01.comptia.org') {
        total_score++
        document.getElementById('inputVal3').style.borderColor = '#77FAAE'
        document.getElementById('inputExt3').style.borderColor = '#77FAAE'
        document.getElementById('inputVal3').style.backgroundColor = '#77FAAE'
        document.getElementById('inputExt3').style.backgroundColor = '#77FAAE'
      }

      if (document.getElementById('inputExt0').textContent === 'policyIdentifier' && document.getElementById('inputVal0').textContent === 'OCSP;URI:http://ocsp.pki.comptia.org') {
        total_score++
        document.getElementById('inputVal0').style.borderColor = '#77FAAE'
        document.getElementById('inputExt0').style.borderColor = '#77FAAE'
        document.getElementById('inputVal0').style.backgroundColor = '#77FAAE'
        document.getElementById('inputExt0').style.backgroundColor = '#77FAAE'
      }
      if (document.getElementById('inputExt1').textContent === 'policyIdentifier' && document.getElementById('inputVal1').textContent === 'OCSP;URI:http://ocsp.pki.comptia.org') {
        total_score++
        document.getElementById('inputVal1').style.borderColor = '#77FAAE'
        document.getElementById('inputExt1').style.borderColor = '#77FAAE'
        document.getElementById('inputVal1').style.backgroundColor = '#77FAAE'
        document.getElementById('inputExt1').style.backgroundColor = '#77FAAE'
      }
      if (document.getElementById('inputExt2').textContent === 'policyIdentifier' && document.getElementById('inputVal2').textContent === 'OCSP;URI:http://ocsp.pki.comptia.org') {
        total_score++
        document.getElementById('inputVal2').style.borderColor = '#77FAAE'
        document.getElementById('inputExt2').style.borderColor = '#77FAAE'
        document.getElementById('inputVal2').style.backgroundColor = '#77FAAE'
        document.getElementById('inputExt2').style.backgroundColor = '#77FAAE'
      }
      if (document.getElementById('inputExt3').textContent === 'policyIdentifier' && document.getElementById('inputVal3').textContent === 'OCSP;URI:http://ocsp.pki.comptia.org') {
        total_score++
        document.getElementById('inputVal3').style.borderColor = '#77FAAE'
        document.getElementById('inputExt3').style.borderColor = '#77FAAE'
        document.getElementById('inputVal3').style.backgroundColor = '#77FAAE'
        document.getElementById('inputExt3').style.backgroundColor = '#77FAAE'
      }

      if (document.getElementById('inputExt0').textContent === 'subjAltName' && document.getElementById('inputVal0').textContent === 'DNS Name=*.comptia.org') {
        total_score++
        document.getElementById('inputVal0').style.borderColor = '#77FAAE'
        document.getElementById('inputExt0').style.borderColor = '#77FAAE'
        document.getElementById('inputVal0').style.backgroundColor = '#77FAAE'
        document.getElementById('inputExt0').style.backgroundColor = '#77FAAE'
      }
      if (document.getElementById('inputExt1').textContent === 'subjAltName' && document.getElementById('inputVal1').textContent === 'DNS Name=*.comptia.org') {
        total_score++
        document.getElementById('inputVal1').style.borderColor = '#77FAAE'
        document.getElementById('inputExt1').style.borderColor = '#77FAAE'
        document.getElementById('inputVal1').style.backgroundColor = '#77FAAE'
        document.getElementById('inputExt1').style.backgroundColor = '#77FAAE'
      }
      if (document.getElementById('inputExt2').textContent === 'subjAltName' && document.getElementById('inputVal2').textContent === 'DNS Name=*.comptia.org') {
        total_score++
        document.getElementById('inputVal2').style.borderColor = '#77FAAE'
        document.getElementById('inputExt2').style.borderColor = '#77FAAE'
        document.getElementById('inputVal2').style.backgroundColor = '#77FAAE'
        document.getElementById('inputExt2').style.backgroundColor = '#77FAAE'
      }
      if (document.getElementById('inputExt3').textContent === 'subjAltName' && document.getElementById('inputVal3').textContent === 'DNS Name=*.comptia.org') {
        total_score++
        document.getElementById('inputVal3').style.borderColor = '#77FAAE'
        document.getElementById('inputExt3').style.borderColor = '#77FAAE'
        document.getElementById('inputVal3').style.backgroundColor = '#77FAAE'
        document.getElementById('inputExt3').style.backgroundColor = '#77FAAE'
      }

      if (document.getElementById('inputVal0').style.borderColor !== 'rgb(119, 250, 174)' && (document.getElementById('inputExt0').style.borderColor !== 'rgb(119, 250, 174)')) {
        document.getElementById('inputVal0').style.borderColor = '#fd4445'
        document.getElementById('inputExt0').style.borderColor = '#fd4445'
        document.getElementById('inputVal0').style.backgroundColor = '#fd4445'
        document.getElementById('inputExt0').style.backgroundColor = '#fd4445'
      }

      if (document.getElementById('inputVal1').style.borderColor !== 'rgb(119, 250, 174)' && (document.getElementById('inputExt1').style.borderColor !== 'rgb(119, 250, 174)')) {
        document.getElementById('inputVal1').style.borderColor = '#fd4445'
        document.getElementById('inputExt1').style.borderColor = '#fd4445'
        document.getElementById('inputVal1').style.backgroundColor = '#fd4445'
        document.getElementById('inputExt1').style.backgroundColor = '#fd4445'
      }


      if (document.getElementById('inputVal2').style.borderColor !== 'rgb(119, 250, 174)' && (document.getElementById('inputExt2').style.borderColor !== 'rgb(119, 250, 174)')) {
        document.getElementById('inputVal2').style.borderColor = '#fd4445'
        document.getElementById('inputExt2').style.borderColor = '#fd4445'
        document.getElementById('inputVal2').style.backgroundColor = '#fd4445'
        document.getElementById('inputExt2').style.backgroundColor = '#fd4445'
      }


      if (document.getElementById('inputVal3').style.borderColor !== 'rgb(119, 250, 174)' && (document.getElementById('inputExt3').style.borderColor !== 'rgb(119, 250, 174)')) {
        document.getElementById('inputVal3').style.borderColor = '#fd4445'
        document.getElementById('inputExt3').style.borderColor = '#fd4445'
        document.getElementById('inputVal3').style.backgroundColor = '#fd4445'
        document.getElementById('inputExt3').style.backgroundColor = '#fd4445'
      }


      if (total_score === this.dataLocal.legacy.total_score) {
        return this.$emit('simulation_full_correct', total_score)
      }

      this.$emit('simulation_getting_there', total_score)

    }

  },
  components: {
    draggable,
    Prism
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  }

}
</script>

